// extracted by mini-css-extract-plugin
export default {"title":"mT23X","count":"lLjRC","replenish-button":"IP938"};